import type { ReactNode } from "react";

import { poolMarkInitials } from "../pools/poolsListState";

export type typeConfirmGateWinnerRowProps = {
  displayName: string;
  medalName: string;
  /** `md` for the gate's own rows, `sm` for the compact pool home card row. */
  size?: "md" | "sm";
};

export const ConfirmGateWinnerRow = ({
  displayName,
  medalName,
  size = "md",
}: typeConfirmGateWinnerRowProps): ReactNode => {
  const plateSize = size === "md" ? "size-12" : "size-8";

  return (
    <div
      data-testid="confirm-gate-winner-row"
      className="flex items-center gap-3"
    >
      <span
        aria-hidden="true"
        className={`grid ${plateSize} shrink-0 place-items-center rounded-full bg-ink-secondary text-caption font-bold text-ink-inverse`}
      >
        {poolMarkInitials(displayName)}
      </span>
      <div className="flex flex-col">
        <p className="text-body font-bold text-ink">{displayName}</p>
        <span
          data-testid="confirm-gate-medal-chip"
          className="inline-flex items-center gap-1 text-caption text-warning"
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            focusable="false"
            className="h-icon-sm w-icon-sm"
          >
            <circle cx="12" cy="15" r="5" />
            <path d="M9 10.5 6 3h4l2 5 2-5h4l-3 7.5" />
          </svg>
          {medalName}
        </span>
      </div>
    </div>
  );
};
